module.exports = __webpack_public_path__ + "play.a1ea6519.png";